const raydiumAuthorityV4 = '5Q544fKrFoe6tsEbD7S8EmxGTJYAKtTVhAW5Q5pge4j1';
const USDT = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB';
const USDC = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
const openbookProgramId = 'srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX';

const pumpAmmProtocolFees = [
    'FWsW1xNtWscwNmKv6wVsU1iTzRN6wmmk3MjxRP5tT7hz', //fee 1
    'G5UZAVbAf46s7cKWoyKu8kYTip9DGTpbLZ2qa9Aq69dP', //fee 2
    '7hTckgnGnLQR6sdH7YkqFTAA7VwTfYFaZ6EhEsU3saCX', //fee 3
    '9rPYyANsfQZw3DnDmKE3YCQF5E8oD89UXoHn9JFEhJUz', //fee 4
    '7VtfL8fvgNfhz17qKRMjzQEXgbdpnHHHQRh54R9jP2RJ', //fee 5
    'AVmoTthdrX6tKt4nDjco2D775W2YK3sDhxPcMmzUAmTY', //fee 6
    '62qc2CNXwrYqQScmEdiZFFAnJR262PxWEuNQtxfafNgV', //fee 7
    'JCRGumoE9Qi5BBgULTgdgTLjSgkCMSbF62ZZfGs84JeU', //fee 8
];

export { raydiumAuthorityV4, USDT, USDC, openbookProgramId, pumpAmmProtocolFees };
